import { RootState } from '@/store/Reducer'

export const selectBetaFeaturesTools = (state: RootState) => state.betaFeaturesTools
